export default __webpack_public_path__ + "static/media/devtrails.a5944757.svg";